export const ADD_FLASH_MESSAGE                  = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE               = 'DELETE_FLASH_MESSAGE';
export const FETCH_MESSAGES_FAILURE               = 'FETCH_MESSAGES_FAILURE';
export const FETCH_MESSAGES_SUCCESS               = 'FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_REQUEST               = 'FETCH_MESSAGES_REQUEST';